import { ApiHelper } from './apiHelper';

export class DealerApi {
    getStateDealers(token, callback, failureCallback, signal) {
        const dataUrl = '/api/dealer/getStateDealers';

        new ApiHelper().getDataSecureAsync(
            dataUrl,
            token,
            callback,
            failureCallback,
            signal
        );
    }

    getProvinceDealers(token, callback, failureCallback, signal) {
        const dataUrl = '/api/dealer/getProvinceDealers';

        new ApiHelper().getDataSecureAsync(
            dataUrl,
            token,
            callback,
            failureCallback,
            signal
        );
    }
}
